import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics tracking function
declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: any) => void;
  }
}

export function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes
    // TODO: Replace G-XXXXXXXXXX with your actual Google Analytics 4 Measurement ID
    // Get it from: https://analytics.google.com/ > Admin > Data Streams
    if (typeof window !== 'undefined' && window.gtag) {
      const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // Replace with your GA4 ID
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user engagement
export const trackUserEngagement = (action: string, details?: Record<string, any>) => {
  trackEvent(action, 'engagement', JSON.stringify(details));
};

// Track feature usage
export const trackFeatureUsage = (feature: string, action: string, details?: Record<string, any>) => {
  trackEvent(action, `feature_${feature}`, JSON.stringify(details));
};